<template lang="pug">
modal#edit-recipient-modal.text-center(
  :buttonColor='false'
  :disableProcessButton='errors.length > 0'
  :noFooter='true'
  :title='$t("modal.editRecipient.title")'
  @closed='deselect'
  close-button-label='$t("button.cancel")'
  process-button-label='$t("button.edit")'
  ref='modal'
  size='sm'
)
  #edit-recipient(ref='edit' v-show='processStep === 1')
    ValidationObserver(ref='form' v-slot='{ valid, passes }')
      form(@submit.prevent='passes(edit)')
        ValidationProvider(
          :name='$t("modal.editRecipient.nameLabel").toLowerCase()'
          rules='required'
          v-slot='{ errors }'
        )
          label.text-start.ps-1.mb-2(for='name') {{ $t('modal.editRecipient.nameLabel') }}
          .form-control-icon
            icon(name='user')
            input#name.form-control(
              :class='{ "border border-danger": errors[0] }'
              :placeholder='$t("modal.editRecipient.namePlaceholder")'
              autocomplete='off'
              type='text'
              v-model='newRecipient.name'
            )
          small.align-items-center.text.text-danger.d-flex(
            v-if='errors.length > 0'
          )
            icon(name='xmark')
            span.text.ms-2 {{ errors[0] }}
        ValidationProvider(
          :name='$t("modal.editRecipient.currentVia").toLowerCase()'
          key='envelope-via'
          rules='required'
          v-slot='{ errors }'
        )
          label.text-start.ps-1.mt-4.mb-2(for='via') {{ $t('modal.editRecipient.currentVia') }}
          .form-control-icon
            select#via.form-select(
              :class='{ "border border-danger": errors[0] }'
              @change='onViaChange'
              v-model='newRecipient.via'
            )
              option(:value='"email"') {{ $t('modal.editRecipient.emailOption') }}
              option(:value='"whatsapp"') {{ $t('modal.editRecipient.whatsappOption') }}
          small.align-items-center.text.text-danger.d-flex(
            v-if='errors.length > 0'
          )
            icon(name='xmark')
            span.text.ms-2 {{ errors[0] }}
        ValidationProvider(
          :name='$t("modal.editRecipient.emailLabel").toLowerCase()'
          key='via-email'
          rules='required|email'
          v-if='newRecipient.via === "email"'
          v-slot='{ errors }'
        )
          label.text-start.ps-1.mt-4.mb-2(for='email') {{ $t('modal.editRecipient.emailLabel') }}
          .form-control-icon
            icon(name='at')
            input#email.form-control(
              :class='{ "border border-danger": errors[0] }'
              :placeholder='$t("modal.editRecipient.emailPlaceholder")'
              autocomplete='off'
              type='text'
              v-model='newRecipient.email'
            )
          small.align-items-center.text.text-danger.d-flex(
            v-if='errors.length > 0'
          )
            icon(name='xmark')
            span.text.ms-2 {{ errors[0] }}
        ValidationProvider(
          :name='$t("modal.editRecipient.phoneLabel").toLowerCase()'
          :rules='{ required: true, intBrazilianPhone: isBrazilPhone, internationalPhone: !isBrazilPhone }'
          key='via-whatsapp'
          v-if='newRecipient.via === "whatsapp"'
          v-slot='{ errors }'
        )
          label.text-start.ps-1.mt-4.mb-2(for='email') {{ $t('modal.editRecipient.phoneLabel') }}
          .form-control-icon
            icon(name='phone')
            input-tel#phone.form-control(
              :class='{ "border border-danger": errors[0] }'
              :placeholder='$t("modal.editRecipient.phonePlaceholder")'
              @is-brazil-changed='isBrazilPhone = $event'
              autocomplete='off'
              key='phone'
              type='text'
              v-model='newRecipient.phone'
            )
          small.align-items-center.text.text-danger.d-flex(
            v-if='errors.length > 0'
          )
            icon(name='xmark')
            span.text.ms-2 {{ errors[0] }}
        .text-end
          button.btn.btn-secondary.mt-5(@click='closeAction' type='button') {{ $t('button.cancel') }}
          button.btn.btn-primary.ms-3.mt-5(
            :disabled='!valid'
            @click='next'
            type='button'
          )
            | {{ $t('button.edit') }}
  #confirm-recipient(ref='confirm' v-show='processStep === 2')
    p.text-start {{ $t('modal.editRecipient.confirmMessage') }}
    .current.d-flex.flex-column.text-start.mb-3
      label.fw-bold {{ $t('modal.editRecipient.currentLabel') }}
      span {{ $t('modal.editRecipient.currentName') }}: {{ recipient.addressees[0].name }}
      span {{ $t('modal.editRecipient.currentVia') }}: {{ recipient.addressees[0].via }}
      span(v-if='recipient.addressees[0].via === "email"') {{ $t('modal.editRecipient.currentEmail') }}: {{ recipient.addressees[0].value }}
      span(v-else) {{ $t('modal.editRecipient.currentPhone') }}: {{ recipient.addressees[0].value }}
    .modified.d-flex.flex-column.text-start
      label.fw-bold {{ $t('modal.editRecipient.modifiedLabel') }}
      span {{ $t('modal.editRecipient.modifiedName') }}: {{ newRecipient.name }}
      span {{ $t('modal.editRecipient.currentVia') }}: {{ newRecipient.via }}
      span(v-if='newRecipient.via === "email"') {{ $t('modal.editRecipient.modifiedEmail') }}: {{ newRecipient.email }}
      span(v-else) {{ $t('modal.editRecipient.modifiedPhone') }}: {{ newRecipient.phone }}
    .text-end
      button.btn.btn-secondary.mt-5(@click='closeAction' type='button') {{ $t('button.cancel') }}
      button.btn.btn-primary.ms-3.mt-5(@click='edit' type='button') {{ $t('button.send') }}
</template>

<script>
import Icon from '@/ui/atoms/Icon.vue';
import Modal from '@/ui/molecules/Modal.vue';
import InputTel from '@/ui/molecules/InputTel.vue';

export default {
  name: 'EditRecipientModal',

  props: {
    recipient: {
      type: Object,
      required: true,
    },
  },
  components: {
    Icon,
    Modal,
    InputTel,
  },
  data() {
    return {
      modalTitle: this.$t('modal.editRecipient.title'),
      processStep: 1,
      isBrazilPhone: true,
      newRecipient: {
        name: this.recipient.addressees[0].name,
        email: this.recipient.addressees[0].value,
        phone: this.recipient.addressees[0].value,
        via: this.recipient.addressees[0].via,
      },
      errors: [],
    };
  },
  watch: {
    recipient(newValue) {
      this.newRecipient.name = newValue.addressees[0].name;
      this.newRecipient.email = newValue.addressees[0].value;
      this.newRecipient.phone = newValue.addressees[0].value;
      this.newRecipient.via = newValue.addressees[0].via;
    },
  },
  methods: {
    closeAction() {
      this.deselect();
      this.$refs.modal.close();
    },
    deselect() {
      this.$emit('deselect');
    },
    onViaChange() {
      this.newRecipient.email = '';
      this.newRecipient.phone = '';
    },
    edit() {
      this.$emit('edit', this.newRecipient);
    },
    next() {
      this.modalTitle = this.$t('modal.envelope.sendNotification');
      this.processStep += 1;
    },
  },
};
</script>

<style scoped lang="stylus">
#edit-recipient-modal
  label
    width: 100%
</style>
